function moduleTestimonials(){
	if ( $('.m__testimonials-slider').length ) {
		var i = 1; $('.m__testimonials-slider').each(function() {
			$(this).addClass('m__testimonials-slider-'+i);

			$('.m__testimonials-slider-'+i).slick({
				dots: true,
				arrows:false,
				infinite: true,
				autoplay:false,
				speed: 300,
				slidesToShow: 1,
				fade: true
			});
			
			i++;
		});
	}
}